module.exports = __webpack_public_path__ + "img/kparcel.9344c0ca.png";